export default {
    SET_CONFGURATION_DATA: 'SET_CONFGURATION_DATA'
  };
  